"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SurfaceListItem = exports.SurfaceList = exports.ListItemEditable = exports.ListItemDescription = exports.ListItem = exports.ListGroup = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../svg/Icon");
var _Button = require("../button/Button");
var _TextInput = require("../text-input/TextInput");
var _spinner = require("../spinner/spinner");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ListGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(ListGroup, _React$Component);
  var _super = _createSuper(ListGroup);
  function ListGroup() {
    var _this;
    _classCallCheck(this, ListGroup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderTab", function (tabData) {
      return tabData.map(function (item) {
        return item;
      });
    });
    return _this;
  }
  _createClass(ListGroup, [{
    key: "renderGroupHeading",
    value: function renderGroupHeading() {
      var headingTextClass = this.props.headingClass ? "tl-list-heading-text heading20 " + this.props.headingClass : "tl-list-heading-text heading20";
      return /*#__PURE__*/_react.default.createElement("div", {
        className: headingTextClass
      }, this.props.heading);
    }
  }, {
    key: "render",
    value: function render() {
      var listType = this.props.type ? this.props.type : '';
      var listClass = "tl-list-group tl-ui " + listType;
      var classVal = this.props.className ? listClass + ' ' + this.props.className : listClass;
      var tabData = _react.default.Children.toArray(this.props.children);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.props.heading ? this.renderGroupHeading() : '', /*#__PURE__*/_react.default.createElement("div", {
        className: classVal,
        id: this.props.id
      }, this.renderTab(tabData)));
    }
  }]);
  return ListGroup;
}(_react.default.Component);
exports.ListGroup = ListGroup;
var ListItem = /*#__PURE__*/function (_React$Component2) {
  _inherits(ListItem, _React$Component2);
  var _super2 = _createSuper(ListItem);
  function ListItem() {
    _classCallCheck(this, ListItem);
    return _super2.apply(this, arguments);
  }
  _createClass(ListItem, [{
    key: "getItemData",
    value: function getItemData(listItem) {
      var listType = listItem.type ? listItem.type : '';
      var listClass = "tl-list-group-item heading16 " + listType;
      var listItemClass = this.props.itemClass ? listClass + this.props.itemClass : listClass;
      listItemClass = listItem.itemDivider ? listItemClass + ' tl-list-item-divider' : listItemClass;
      var itemIconClass = this.props.itemIconClass ? "tl-svg-info-icon " + this.props.itemIconClass : "tl-svg-info-icon ";
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.props.wrapperClass
      }, listItem.icon ? /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-list-left-icon"
      }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
        className: itemIconClass,
        name: listItem.icon
      })) : '', /*#__PURE__*/_react.default.createElement("div", {
        className: listItemClass,
        id: listItem.id
      }, /*#__PURE__*/_react.default.createElement("span", null, listItem.itemText), listItem.rightIcon ? /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
        className: "tl-svg-info-icon tl-list-item-rightIcon",
        name: listItem.rightIcon
      }) : '', listItem.children));
    }
  }, {
    key: "render",
    value: function render() {
      return this.getItemData(this.props);
    }
  }]);
  return ListItem;
}(_react.default.Component);
exports.ListItem = ListItem;
var SurfaceList = /*#__PURE__*/function (_React$Component3) {
  _inherits(SurfaceList, _React$Component3);
  var _super3 = _createSuper(SurfaceList);
  function SurfaceList() {
    _classCallCheck(this, SurfaceList);
    return _super3.apply(this, arguments);
  }
  _createClass(SurfaceList, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-surface-list__container"
      }, this.props.header ? /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-surface-header"
      }, this.props.header) : null, this.props.body ? /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-surface-body"
      }, this.props.body) : null, this.props.footer ? /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-surface-footer"
      }, this.props.footer) : null);
    }
  }]);
  return SurfaceList;
}(_react.default.Component);
exports.SurfaceList = SurfaceList;
var SurfaceListItem = /*#__PURE__*/function (_React$Component4) {
  _inherits(SurfaceListItem, _React$Component4);
  var _super4 = _createSuper(SurfaceListItem);
  function SurfaceListItem() {
    var _this2;
    _classCallCheck(this, SurfaceListItem);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _super4.call.apply(_super4, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this2), "onClick", function (e) {
      if (_this2.props.onClick) {
        _this2.props.onClick(_this2.props.itemId);
      }
    });
    _defineProperty(_assertThisInitialized(_this2), "onKeyDown", function (event) {
      if (event.key === "Enter" || event.key === " " || event.key === "Space") {
        _this2.onClick(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this2), "getNumberClass", function (itemNum) {
      var newItemNum = String(itemNum);
      var itemNumClass = '';
      if (newItemNum.length === 2) {
        itemNumClass = 'two_digit';
      } else if (newItemNum.length === 3) {
        itemNumClass = 'three_digit';
      } else if (newItemNum.length === 4) {
        itemNumClass = 'four_digit';
      } else if (newItemNum.length === 5) {
        itemNumClass = 'five_digit';
      } else if (newItemNum.length > 5) {
        itemNumClass = 'six_digit';
        itemNum = 99999 + '+';
      }
      return [itemNumClass, itemNum];
    });
    _defineProperty(_assertThisInitialized(_this2), "getItemContent", function (itemWrapperClass) {
      var _this2$props = _this2.props,
        itemHeading = _this2$props.itemHeading,
        itemNumber = _this2$props.itemNumber,
        itemIcon = _this2$props.itemIcon,
        itemBodyContent = _this2$props.itemBodyContent,
        skeltonLoading = _this2$props.skeltonLoading,
        itemIconError = _this2$props.itemIconError;
      var itemNumAttributes = _this2.getNumberClass(itemNumber);
      var itemNumClass = '__number ' + itemNumAttributes[0];
      var skeltonLoadingClass = skeltonLoading ? 'tl-loading' : '';
      var numberClass = '__right ' + skeltonLoadingClass;
      var itemBodyContentClass = itemWrapperClass + ' ' + skeltonLoadingClass;
      var headingClass = skeltonLoadingClass + (itemHeading && itemHeading.length > 23 ? ' __more_heading' : '');
      return itemBodyContent ? /*#__PURE__*/_react.default.createElement("div", {
        className: itemBodyContentClass,
        onClick: _this2.onClick,
        onKeyDown: _this2.onKeyDown,
        tabIndex: 0
      }, skeltonLoadingClass ? /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-loading tl-store-loading"
      }) : _this2.props.itemBodyContent) : /*#__PURE__*/_react.default.createElement("div", {
        className: itemWrapperClass,
        onClick: _this2.onClick,
        onKeyDown: _this2.onKeyDown,
        tabIndex: 0
      }, itemHeading ? /*#__PURE__*/_react.default.createElement("div", {
        className: headingClass
      }, itemHeading) : null, /*#__PURE__*/_react.default.createElement("div", {
        className: numberClass
      }, !itemIconError && itemNumber > 0 ? /*#__PURE__*/_react.default.createElement("div", {
        className: itemNumClass
      }, itemNumAttributes[1]) : '', itemIcon ? /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
        className: "tl-svg-info-icon tl-list-item-rightIcon",
        name: itemIcon
      }) : null));
    });
    _defineProperty(_assertThisInitialized(_this2), "getItemDesContent", function (itemWrapperClass) {
      var _this2$props2 = _this2.props,
        itemHeading = _this2$props2.itemHeading,
        itemNumber = _this2$props2.itemNumber,
        itemIcon = _this2$props2.itemIcon,
        itemBadge = _this2$props2.itemBadge,
        itemDesc = _this2$props2.itemDesc,
        skeltonLoading = _this2$props2.skeltonLoading,
        itemIconError = _this2$props2.itemIconError;
      var itemNumAttributes = _this2.getNumberClass(itemNumber);
      var itemNumClass = '__number ' + itemNumAttributes[0];
      var skeltonLoadingClass = skeltonLoading ? 'tl-loading' : '';
      var numberClass = '__right ' + skeltonLoadingClass;
      var descClass = '__desc ' + skeltonLoadingClass;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: itemWrapperClass,
        onClick: _this2.onClick,
        onKeyDown: _this2.onKeyDown,
        tabIndex: 0
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "__item_wrapper"
      }, itemHeading ? /*#__PURE__*/_react.default.createElement("div", {
        className: skeltonLoadingClass
      }, itemHeading) : null, /*#__PURE__*/_react.default.createElement("div", {
        className: numberClass
      }, !itemIconError && itemNumber > 0 ? /*#__PURE__*/_react.default.createElement("div", {
        className: itemNumClass
      }, itemNumAttributes[1]) : null, !itemIconError && itemBadge ? itemBadge : null, itemIcon ? /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
        className: "tl-svg-info-icon tl-list-item-rightIcon",
        name: itemIcon
      }) : null)), /*#__PURE__*/_react.default.createElement("div", {
        className: "__item_wrapper __wrapper_desc"
      }, itemDesc ? /*#__PURE__*/_react.default.createElement("div", {
        className: descClass
      }, itemDesc) : null));
    });
    return _this2;
  }
  _createClass(SurfaceListItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        itemDesc = _this$props.itemDesc,
        itemClassName = _this$props.itemClassName,
        skeltonLoading = _this$props.skeltonLoading,
        itemIconError = _this$props.itemIconError;
      var itemWrapperClass = (itemClassName ? itemClassName : '') + (!itemDesc ? ' __list__item' : ' __list__item__desc');
      itemWrapperClass = itemWrapperClass + (skeltonLoading ? ' tl-skelton-loading' : '') + (itemIconError ? ' __list-item-error' : '');
      return !itemDesc ? this.getItemContent(itemWrapperClass) : this.getItemDesContent(itemWrapperClass);
    }
  }]);
  return SurfaceListItem;
}(_react.default.Component);
exports.SurfaceListItem = SurfaceListItem;
var ListItemDescription = /*#__PURE__*/function (_React$Component5) {
  _inherits(ListItemDescription, _React$Component5);
  var _super5 = _createSuper(ListItemDescription);
  function ListItemDescription() {
    _classCallCheck(this, ListItemDescription);
    return _super5.apply(this, arguments);
  }
  _createClass(ListItemDescription, [{
    key: "render",
    value: function render() {
      var className = this.props.className ? "tl-list-group-description body16 " + this.props.className : "tl-list-group-description body16";
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, this.props.children));
    }
  }]);
  return ListItemDescription;
}(_react.default.Component);
exports.ListItemDescription = ListItemDescription;
var ListItemEditable = /*#__PURE__*/function (_React$Component6) {
  _inherits(ListItemEditable, _React$Component6);
  var _super6 = _createSuper(ListItemEditable);
  function ListItemEditable(props) {
    var _this3;
    _classCallCheck(this, ListItemEditable);
    _this3 = _super6.call(this, props);
    _defineProperty(_assertThisInitialized(_this3), "listEditHandler", function (event) {
      var parentDivClass, nextSiblingDiv;
      parentDivClass = event.target.parentNode;
      nextSiblingDiv = parentDivClass.nextSibling;
      parentDivClass.classList.add('tl-list-item-hide');
      nextSiblingDiv.classList.remove('tl-list-item-hide');
    });
    _defineProperty(_assertThisInitialized(_this3), "listCancelHandler", function (event) {
      var grandParentDivClass, prevSiblingDiv;
      grandParentDivClass = event.target.parentNode.parentNode;
      prevSiblingDiv = grandParentDivClass.previousSibling;
      prevSiblingDiv.classList.remove('tl-list-item-hide');
      grandParentDivClass.classList.add('tl-list-item-hide');
    });
    _defineProperty(_assertThisInitialized(_this3), "inputChangeHandler", function (event) {
      var inputValue, inputValueValidation, disabledSaveButton;
      inputValue = event.target.value && event.target.value.trim() ? event.target.value.trim() : '';
      inputValueValidation = inputValue.length > 0 && inputValue.length < 25 ? true : false;
      if (inputValueValidation) {
        inputValue = inputValue;
        disabledSaveButton = false;
      } else {
        inputValue = '';
        disabledSaveButton = true;
      }
      _this3.setState({
        inputValue: inputValue,
        disabledSaveButton: disabledSaveButton
      });
    });
    _defineProperty(_assertThisInitialized(_this3), "listSaveHandler", function (event) {
      var saveButton, sendingButton, itemNameValue, grandParentDivClass, prevSiblingDiv;
      saveButton = event.target;
      sendingButton = saveButton.nextSibling;
      itemNameValue = _this3.state.inputValue;
      grandParentDivClass = saveButton.parentNode.parentNode;
      prevSiblingDiv = grandParentDivClass.previousSibling;
      saveButton.classList.add('tl-list-item-hide');
      sendingButton.classList.remove('tl-list-item-hide');
      setTimeout(function () {
        _this3.setState({
          itemNameValue: itemNameValue
        });
        saveButton.classList.remove('tl-list-item-hide');
        sendingButton.classList.add('tl-list-item-hide');
        prevSiblingDiv.classList.remove('tl-list-item-hide');
        grandParentDivClass.classList.add('tl-list-item-hide');
      }, 4000);
      if (_this3.props.updatedText) {
        _this3.props.updatedText(_this3.props.itemId, itemNameValue);
      }
    });
    _this3.state = {
      inputValue: '',
      disabledSaveButton: true,
      itemNameValue: props.itemName
    };
    return _this3;
  }
  _createClass(ListItemEditable, [{
    key: "render",
    value: function render() {
      var className = this.props.className ? "tl-list-group-description body16 " + this.props.className : "tl-list-group-description body16";
      var disabledSaveButton = this.state && !this.state.disabledSaveButton ? this.state.disabledSaveButton : true;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "list-description-edit",
        id: "list-item-edit-div-".concat(this.props.itemId)
      }, /*#__PURE__*/_react.default.createElement("span", null, this.state && this.state.itemNameValue ? this.state.itemNameValue : ''), /*#__PURE__*/_react.default.createElement(_Button.Button, {
        variant: "secondary",
        size: "xSmall",
        onClick: this.listEditHandler
      }, this.props.buttonText)), /*#__PURE__*/_react.default.createElement("div", {
        className: "list-description-save tl-list-item-hide",
        id: "list-item-save-div-".concat(this.props.itemId)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "list-input-box"
      }, /*#__PURE__*/_react.default.createElement(_TextInput.TextInput, {
        name: "list-item-2",
        onChange: this.inputChangeHandler,
        required: true,
        assistiveText: this.props.assistiveText
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "list-edit-buttons"
      }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
        variant: "secondary",
        size: "xSmall",
        className: "list-edit-cancel",
        onClick: this.listCancelHandler
      }, "Cancel"), /*#__PURE__*/_react.default.createElement(_Button.Button, {
        variant: "primary",
        size: "xSmall",
        className: "list-edit-save",
        onClick: this.listSaveHandler,
        disabled: disabledSaveButton
      }, "Save"), /*#__PURE__*/_react.default.createElement(_Button.Button, {
        variant: "secondary",
        size: "xSmall",
        className: "list-edit-sending tl-list-item-hide",
        disabled: true
      }, /*#__PURE__*/_react.default.createElement(_spinner.Spinner, {
        size: "tl-spinner-small"
      })))));
    }
  }]);
  return ListItemEditable;
}(_react.default.Component);
exports.ListItemEditable = ListItemEditable;